module.exports = __webpack_public_path__ + "static/img/business66.ca75490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business66.jpg
// module id = f+Rm
// module chunks = 9